// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__CIYTU","cardContainer":"Card_cardContainer__P301l","titleWrapper":"Card_titleWrapper__Re2fY"};